import { CoreMessages, PluginMessages } from './features';
export default class IntegratedAppOption {
  constructor() {
    this.options = [];
  }
  setRefreshToken(refreshToken) {
    this.options.push({
      key: CoreMessages.SendRefreshToken,
      payload: refreshToken
    });
    return this;
  }
  setLocale(locale) {
    this.options.push({
      key: CoreMessages.SendLocale,
      payload: locale
    });
    return this;
  }
  setDeviceId(deviceId) {
    this.options.push({
      key: CoreMessages.SendDeviceId,
      payload: deviceId
    });
    return this;
  }
  flush() {
    this.options = [];
  }
  setIntegratedAppConfig(config) {
    this.options.push({
      key: CoreMessages.SendIntegratedAppConfig,
      payload: config
    });
    return this;
  }
  setLeadinConfig(leadinConfig) {
    this.options.push({
      key: PluginMessages.PluginLeadinConfig,
      payload: leadinConfig
    });
    return this;
  }
}